import RcsSectionUtils from './utils/RcsSectionUtils';
import RcsUtils from './utils/RcsUtils';
import InfiniteLink from './InfiniteLink';

class ArticlesList {
  constructor(obj) {
    this.uuid = obj.uuid;
    this.rcsSection = RcsSectionUtils.getRcsSection();
    this.rcsSubSection = RcsSectionUtils.getRcsSubSection();
    this.isLocal = RcsSectionUtils.checkIfIsLocal(this.rcsSection);
    this.baseUrl = 'https://www.corriere.it/tools/3a-col-nav/';
    this.navBaseUrl = window.corriereHNavBaseurl || this.baseUrl;
    this.data = {};
    this.IDs = [];
    this.json = null;
    this.loop = false;
    this.blockers = {
      artLoad: false,
      itemLoad: false,
      scroll: false,
      linkLoad: false,
      force: false
    };
  }

  init() {
    this.load();
  }

  compose() {
    this.parseList();
    this.initLoop();
  }

  initLoop() {
    this.loop = new InfiniteLink({
      parent: this
    });
    this.loop.init();
  }

  parseList() {
    for (let _x = 0; _x < this.json.length; _x++) {
      let a = this.json[_x];
      if (
        a.url.match('/cards/') ||
        typeof this.data[a.uid] !== 'undefined' ||
        a.uid === this.uuid
      ) {
        continue;
      }
      this.data[a.uid] = a;
      this.IDs.push(a.uid);
    }

    delete this.json;
  }

  load() {
    let urlJson = `${this.navBaseUrl}${this.rcsSection}_`;

    if (this.rcsSubSection === 'speciale') {
      urlJson = `${urlJson}${window.testataSpeciale}`;
    } else {
      urlJson = `${urlJson}${this.rcsSubSection}`;
    }
    urlJson = `${urlJson}.json`;

    RcsUtils.fetchJson(urlJson, j => {
      this.json = j.last_articles;
      try {
        this.compose();
      } catch (e) {
        console.warn('[INFINITY SCROLL COMPONENT] Failed Articles JSON.');
      }
    });
  }

  getLabelSezione() {
    let label = '';
    let categoryHeaderElement = document.querySelector('#header .category');

    if (categoryHeaderElement !== null) {
      label = categoryHeaderElement.innerHTML;
    }

    if (typeof window.nomeSpeciale !== 'undefined') {
      label = window.nomeSpeciale;
    }

    return label;
  }

  isBlocked(n) {
    let b = this.blockers;
    if (typeof n !== 'undefined' && n in b) {
      return b[n];
    }

    return b.artLoad || b.itemLoad || b.scroll || b.linkLoad || b.force;
  }

  block(n, t) {
    this.blockers[n] = t;
  }
}

module.exports = ArticlesList;



// WEBPACK FOOTER //
// ./src/rcs_cor_continous-related-link/ArticlesList.js